import { render, staticRenderFns } from "./PartnerDetail.vue?vue&type=template&id=e6dacc6e&scoped=true"
import script from "./PartnerDetail.vue?vue&type=script&lang=js"
export * from "./PartnerDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6dacc6e",
  null
  
)

export default component.exports